import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaUser, FaBriefcase, FaBuilding, FaIdCard, FaEnvelope, FaCalendarAlt } from 'react-icons/fa';

const EmployeeProfileCard = ({ user }) => {
  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const employeeName = user?.employeeName || 
    `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 
    'Employee';

  const profilePhoto = user?.photoURL || 
                       user?.photo || 
                       user?.personal?.photo || 
                       user?.personalInfo?.photo || 
                       user?.profilePicture || 
                       '';

  return (
    <Card className="border-0 shadow-sm employee-profile-card">
      <Card.Body className="p-4">
        <Row className="align-items-center">
          {/* Avatar */}
          <Col xs={12} md={3} className="text-center mb-3 mb-md-0">
            <div className="profile-avatar">
              {profilePhoto ? (
                <img 
                  src={profilePhoto} 
                  alt={employeeName} 
                  className="avatar-img shadow-sm"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ) : (
                <div className="avatar-initials">
                  {getInitials(employeeName)}
                </div>
              )}
            </div>
            <h5 className="mt-3 mb-1 fw-bold">{employeeName}</h5>
            <span className="text-muted">{user?.designation || 'Employee'}</span>
          </Col>

          {/* Profile Details */}
          <Col xs={12} md={9}>
            <Row>
              <Col xs={6} md={4} className="mb-3">
                <div className="profile-info-item">
                  <FaIdCard className="info-icon text-primary" />
                  <div className="info-content">
                    <span className="info-label">Employee Code</span>
                    <span className="info-value">{user?.employeeCode || user?.employeeId || 'N/A'}</span>
                  </div>
                </div>
              </Col>

              <Col xs={6} md={4} className="mb-3">
                <div className="profile-info-item">
                  <FaBuilding className="info-icon text-success" />
                  <div className="info-content">
                    <span className="info-label">Department</span>
                    <span className="info-value">{user?.department || 'N/A'}</span>
                  </div>
                </div>
              </Col>

              <Col xs={6} md={4} className="mb-3">
                <div className="profile-info-item">
                  <FaBriefcase className="info-icon text-warning" />
                  <div className="info-content">
                    <span className="info-label">Designation</span>
                    <span className="info-value">{user?.designation || 'N/A'}</span>
                  </div>
                </div>
              </Col>

              <Col xs={6} md={4} className="mb-3 mb-md-0">
                <div className="profile-info-item">
                  <FaEnvelope className="info-icon text-info" />
                  <div className="info-content">
                    <span className="info-label">Email</span>
                    <span className="info-value text-truncate" title={user?.email}>
                      {user?.email || 'N/A'}
                    </span>
                  </div>
                </div>
              </Col>

              <Col xs={6} md={4}>
                <div className="profile-info-item">
                  <FaCalendarAlt className="info-icon text-danger" />
                  <div className="info-content">
                    <span className="info-label">Joining Date</span>
                    <span className="info-value">{formatDate(user?.joiningDate)}</span>
                  </div>
                </div>
              </Col>

              <Col xs={6} md={4}>
                <div className="profile-info-item">
                  <FaUser className="info-icon text-secondary" />
                  <div className="info-content">
                    <span className="info-label">Employment Type</span>
                    <span className="info-value">{user?.employmentType || 'Full Time'}</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EmployeeProfileCard;
